
import {defineMessages} from 'react-intl';

export const SearchResultsMessages = [
  defineMessages({
    'Events': {
      id: 'SearchResults.PillBar.Filters.Events',
      defaultMessage: `Events`
    }}),
  defineMessages({
    'Parking': {
      id: 'SearchResults.PillBar.Filters.Parking',
      defaultMessage: `Parking`
    }})
];

export const ReduxSearchResultsActions = Object.freeze({
  GET_SUGGESTED_PERFORMERS_SUCCESS: 'SEARCH_RESULTS:GET_SUGGESTED_PERFORMERS_SUCCESS',
  GET_SUGGESTED_PERFORMERS_ERROR: 'SEARCH_RESULTS:GET_SUGGESTED_PERFORMERS_ERROR',
  SET_INITIAL_STATE: 'SEARCH_RESULTS:SET_INITIAL_STATE'
});

/**
 * Tab names for the pill bar
 */
export const TABS = ['Events', 'Parking'];

export const SuggestedPerformerConfig = {
  SUGGEST_API_END_POINT: '/search/suggest/v3'
};
